import useCardsV2 from './Product/useCardsV2'

function withProductCardExperiment(Component) {
  return function WrappedComponent(props) {
    const cardsV2 = useCardsV2()
    return <Component {...props} cardsV2={cardsV2} />
  }
}

export default withProductCardExperiment
